import React, { useCallback, useEffect, useState } from 'react'
import {
    View,
    Text,
    Dimensions,
    TouchableOpacity,
    Image,
    FlatList,
    Keyboard,
    PixelRatio,
} from 'react-native'
import { useFocusEffect } from '@react-navigation/native'
import {
    ActivitysModel,
    CampaignModel,
    CampaignRouteModel,
    CampaignScheduleModel,
    CampaignStepsModel,
    CampaignValuesModel,
    ScheduleFormModel,
    StoresListModel,
} from './models/ScheduleModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import {
    colorUnfilled,
    colorFilled,
    colorFilledBis,
    CampaingViewRelevGradient,
} from '../../../themeConstants'
import styles from './CampaignViewStyles'
import { parseDate } from '../customUtils/calculateDates/calculateDates'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { schedulesServices } from '../../../database/schedules.database'
import * as Progress from 'react-native-progress'
import { LinearGradient } from 'expo-linear-gradient'
import { placeholderGeneral } from '../customUtils/Constants'
import { FormsModel, StepsModel } from './models/StoreDetailModel'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { FormProps, useFormContext } from './context/form.context'
import { getForms, SCHEDULES_STORE_NAMES } from '../../db/posSchedules'
import { CampaignStatus, getStatusMap } from './StatusTagsStores'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { format } from 'date-fns'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { formatDate, getCurrentDateObject } from '../../utils/formatDate.function'
import {
    CONSTANTS_TYPES_STEPS,
    FORM_SCHEDULE_STATUS,
} from './constants/constants.stores'
import { getConection } from '../appBar/context/HeaderContext'
import { getLocation } from '../appBar/context/LocationContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_checkin, request_checkout } from '../../services/schedule.services'
import { InputCommentSheet } from './FormItems/InputCommentItem'
import { Ionicons } from '@expo/vector-icons'
import { DistributorItem } from './CreateSchedule'
import Constants from 'expo-constants'
import { UserServices } from '../../../database/user.database'
import {
    getLocalISOStringWithOffset,
    isInvalidData,
    validatesNamesCampaing,
} from '../../utils/functions.utils'
import { StorageAdapter } from '../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from './constants/constants.storage'
import { useChangeColorAsset } from '../../redux/zustand/changeColorAssetPSStore'
import {
    useAlertsGeneralControllersStore,
    useAlertTextPS,
} from '../../redux/zustand/alertsGeneralControllersStore'
import { CLIENTS_SLUGS } from '../../constants/slugs'
import { useScheduleZip } from '@/redux/zustand/scheduleZipStore'

const { width } = Dimensions.get('window')

interface CampaignViewProps {
    campaignValues: CampaignValuesModel[]
    campaignProgress: number
    date: string
    finishDate: string
    form: ScheduleFormModel
    steps?: CampaignStepsModel[]
    schedule_id?: string
    schedule: CampaignScheduleModel
    showAlert: boolean
    selectedDate?: CampaignRouteModel
    selectDay?: (day: any) => void
    scheduleFree?: boolean
    generator: { active: boolean; is_moderator: boolean; title: string }
    buttonDistributor?: StoresListModel
    activities?: ActivitysModel[]
    checkinsDistributor?: (option: string) => void
    showMapButton?: boolean
}

export const CampaignView = ({
    campaignValues,
    campaignProgress,
    date,
    finishDate,
    form,
    steps,
    schedule_id,
    schedule,
    showAlert,
    selectedDate,
    selectDay,
    scheduleFree,
    generator,
    buttonDistributor,
    activities,
    checkinsDistributor,
    showMapButton,
}: CampaignViewProps) => {
    //console.log('🚀 ~ buttonDistributor:', buttonDistributor)
    const { languageFile } = getLanguage()
    const { formsContext } = useFormContext()
    const [showMore, setShowMore] = useState(false)
    const [showMoreMessage, setMoreMessage] = useState(true)
    const [progressRelev, setProgressRelev] = useState(0)
    const [dataProgress, setDataProgress] = useState(null)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [formsProgress, setFormsProgress] = useState([]) //{ _id: '3241341', progress: 72, name: 'MATUTINO 1.1', date: '12/10/2024 - 11:08 am' }
    const [storesProgress, setStoresProgress] = useState([])
    const [progressAdditional, setProgressAdditional] = useState([]) //{ _id: 1, progress: 80, name: 'TMRS' }
    const [checkinDistributor, setCheckinDistributor] = useState(1) // aca se define si esta el checkin realizado
    // console.log('🚀 ~ checkinDistributor:', checkinDistributor)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const { isConnected, hasInternet } = getConection()
    const { userLat, userLng, askAgain } = getLocation()
    const [checksActivities, setChecksActivities] = useState(activities)
    const [checksOthersActivities, setChecksOthersActivities] = useState(activities)
    const [isPerfectStore, setIsPerfectStore] = useState(true)
    // const [isDownloadedComplete, setIsDownloadedComplete] = useState(true)
    const isDownloadedComplete = useChangeColorAsset(
        (state) => state.isDownloadedCompletePS,
    )
    const setIsDownloadedCompletePS = useChangeColorAsset(
        (state) => state.setIsDownloadedCompletePS,
    )
    const showDownloadAssetPS = useChangeColorAsset(
        (state) => state.showDownloadAssetPS,
    )
    const hasStoresZip = useScheduleZip((state) => state.hasStoresZip)
    const setHasStoresZip = useScheduleZip((state) => state.setHasStoresZip)
    const [isPerfectStoreZip, setIsPerfectStoreZip] = useState(false)

    const [checkinData, setCheckinData] = useState({
        checkin_id: null,
        activities: [],
    })
    const NAME_PROGRESS_FORMS = 'Objetivo de RELEVAMIENTOS'

    const areFormsProgressEqual = useCallback((arr1, arr2) => {
        if (arr1.length !== arr2.length) return false

        for (let i = 0; i < arr1.length; i++) {
            const form1 = arr1[i]
            const form2 = arr2[i]

            if (
                form1._id !== form2._id ||
                form1.name !== form2.name ||
                form1.progress !== form2.progress ||
                form1.date !== form2.date
            ) {
                return false
            }
        }

        return true
    }, [])

    const navigateToForms = async (index: number) => {
        let navigate = true
        const today = getLocalISOStringWithOffset().split('T')[0]
        //aca verifico si me deja ir al form o me bloquea un step
        if (steps && steps.length > 0) {
            //PRIMERO BUSCO SI HAY OBJETIVO EN EL AGENDA SINO TOMO EL DE LA CAMP.
            let step = null
            if (
                schedule.additional &&
                schedule.additional.objective &&
                schedule.additional.objective.length > 0 &&
                schedule['form_finish']
            ) {
                //ARMO EL STEP
                step = {
                    date_init: schedule['date_init'],
                    date_finish: schedule['date_finish'],
                    type: 'objective',
                    checkins:
                        parseInt(schedule.additional.objective[0]['objetive']) +
                        schedule.additional.stop_by.length,
                    forms: [
                        {
                            _id: schedule['form_finish']['_id'], //desbloquea el form vespertino
                            status: 2,
                        },
                    ],
                }
            } else {
                step = steps.find(
                    (step) => step.type === CONSTANTS_TYPES_STEPS.OBJECTIVES,
                )
            }
            //me falta validar las fechas
            if (step) {
                const stepDateInit = new Date(step.date_init)
                    .toISOString()
                    .split('T')[0]
                const stepDateFinish = new Date(step.date_finish)
                    .toISOString()
                    .split('T')[0]
                if (
                    stepDateInit <= today &&
                    stepDateFinish >= today &&
                    step.forms.some((item) => item._id === form._id)
                ) {
                    const count =
                        await schedulesServices.get_total_checkin_count(schedule_id)

                    const checkinsComplete = count >= step.checkins
                    const allObjectivesComplete = progressAdditional.every(
                        (item) => item.progress >= 100,
                    )
                    console.log(
                        '🚀 ~ navigateToForms ~ allObjectivesComplete:',
                        allObjectivesComplete,
                    )

                    if (!checkinsComplete || !allObjectivesComplete) {
                        navigate = false
                        let title = languageFile.inactive_vespertino
                        let desc =
                            languageFile.activate_survey +
                            `${step.checkins}, total Check-in: ${count}.`
                        let button = languageFile.accept

                        openBottomSheet(
                            <BottomSheetAlert
                                image={require('../../../assets/stores/inactiveVespertino.png')}
                                title={title}
                                desc={desc}
                                button={button}
                                closeBottomSheet={closeBottomSheet}
                            />,
                            ['50%'],
                        )
                    } else {
                        navigate = true
                    }
                }
            }
        }

        if (navigate) {
            await schedulesServices
                .getForm(form._id)
                .then((get_form) => {
                    navigation.navigate('ExecutionView', {
                        forms: [get_form],
                        selectedIndex: index,
                        schedule_id: form.schedule_id,
                    })
                })
                .finally(() => {
                    AsyncStorage.removeItem('hasSeenModalVesp') //cuando hace el matutinoo vesp elimina el item de asyncStorage
                })
                .catch((error) => console.error(error))
        }
    }

    const calculateRelevProgress = async () => {
        //
        try {
            console.log('🚀 ~ calculateRelevProgress ~ schedule:')
            if (schedule) {
                const { form_init, form_finish, _id, date_init, date_finish } =
                    schedule
                const form_id_init = form_init?._id
                const form_id_finish = form_finish?._id

                const formInitStatus =
                    await schedulesServices.getFormStatusFromAdvances(
                        _id,
                        form_id_init,
                        {
                            date_init: date_init,
                            date_finish: date_finish,
                        },
                    )
                // console.log('🚀 ~ calculateRelevProgress ~ formInitStatus:', formInitStatus)
                const formFinishStatus =
                    await schedulesServices.getFormStatusFromAdvances(
                        _id,
                        form_id_finish,
                        {
                            date_init: date_init,
                            date_finish: date_finish,
                        },
                    )
                // console.log('🚀 ~ calculateRelevProgress ~ formFinishStatus:', formFinishStatus)
                // Construir array de formularios de una sola vez
                let newFormsProgress = []

                if (formInitStatus) {
                    const name = await schedulesServices.getFormName(form_id_init)
                    // console.log('🚀 ~ calculateRelevProgress ~ name:', name)
                    const formData = await schedulesServices.getFormsAnswers(
                        _id,
                        form_id_init,
                    )
                    // console.log('230 - 🚀 ~ calculateRelevProgress ~ formInitData:', formData)
                    if (formData) {
                        newFormsProgress.push({
                            _id: form_id_init,
                            name: name,
                            progress: formInitStatus.score,
                            date: formInitStatus.date_init,
                        })
                    }
                }

                if (formFinishStatus) {
                    const formFinishData = await schedulesServices.getFormsAnswers(
                        _id,
                        form_id_finish,
                    )
                    // console.log('243 - 🚀 ~ calculateRelevProgress ~ formFinishData:', formFinishData)
                    if (formFinishData) {
                        const name =
                            await schedulesServices.getFormName(form_id_finish)
                        newFormsProgress.push({
                            _id: form_id_finish,
                            name: name,
                            progress: formFinishStatus.score,
                            date: formFinishStatus.date_init,
                        })
                    }
                }

                setFormsProgress((prevFormsProgress) => {
                    const isDifferent = !areFormsProgressEqual(
                        prevFormsProgress,
                        newFormsProgress,
                    )
                    if (isDifferent) {
                        console.log(
                            '🔄 Actualizando formsProgress:',
                            newFormsProgress.length,
                            'formularios',
                        )
                        return newFormsProgress
                    }
                    return prevFormsProgress
                })

                let calculatedProgress = 0
                let calculatedDataProgress = null

                //para relevamientos act
                if (steps && steps.length > 0) {
                    let step = null

                    // console.log(
                    //     '🚀🚀🚀🚀 ~ calculateRelevProgress ~ schedule.additional:',
                    //     schedule.additional,
                    // )

                    if (
                        schedule.additional &&
                        schedule.additional.objective &&
                        schedule.additional.objective.length > 0
                    ) {
                        let objective_step = schedule.additional.objective[0]
                        // console.log('🚀🚀🚀🚀 ~ calculateRelevProgress ~ objective_step:', objective_step)

                        if (objective_step['type']) {
                            switch (objective_step['type']) {
                                case CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS:
                                    const formsCountTotal =
                                        await schedulesServices.getProgressByForms(
                                            _id,
                                            objective_step['form'],
                                        )
                                    const progress =
                                        (formsCountTotal /
                                            parseInt(objective_step.objetive)) *
                                        100
                                    const roundedProgress = Math.floor(progress)

                                    calculatedProgress = roundedProgress // ← Guardar en variable local
                                    calculatedDataProgress = {
                                        name: NAME_PROGRESS_FORMS,
                                        progress: progress,
                                        count_total:
                                            formsCountTotal +
                                            '/' +
                                            objective_step.objetive,
                                        relev: formsCountTotal,
                                    }
                                    break

                                case CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP:
                                    //busco el numero de adv con status_objective 1
                                    const count_objectives =
                                        await schedulesServices.countCompletedObjectivesForSchedule(
                                            _id,
                                        )
                                    const progress2 =
                                        (count_objectives /
                                            parseInt(objective_step.objetive)) *
                                        100
                                    const roundedProgress2 = Math.floor(progress2)

                                    calculatedProgress = roundedProgress2 // ← Guardar en variable local
                                    calculatedDataProgress = {
                                        name: NAME_PROGRESS_FORMS,
                                        progress: roundedProgress2,
                                        count_total:
                                            count_objectives +
                                            '/' +
                                            objective_step.objetive,
                                        relev: count_objectives,
                                    }

                                    break

                                default:
                                    step = steps.find(
                                        (step) =>
                                            step.type ===
                                            CONSTANTS_TYPES_STEPS.OBJECTIVES,
                                    )
                                    console.log('STEP ==>', step)
                                    break
                            }
                        } else {
                            //para jti no tiene type
                            step = {
                                date_init: schedule['date_init'],
                                date_finish: schedule['date_finish'],
                                type: 'objective',
                                checkins:
                                    parseInt(
                                        schedule.additional.objective[0]['objetive'],
                                    ) + schedule.additional.stop_by.length,
                                forms: [
                                    {
                                        _id: schedule['form_finish']['_id'], //desbloquea el form vespertino
                                        status: 2,
                                    },
                                ],
                            }
                        }
                    } else {
                        console.log('ENTRE AL ESTE PARA STEP?')
                        step = steps.find(
                            (step) => step.type === CONSTANTS_TYPES_STEPS.OBJECTIVES,
                        )
                        if (step != undefined) {
                            const count =
                                await schedulesServices.get_total_checkin_count(_id)
                            const progress = (count / step?.checkins) * 100
                            const roundedProgress = Math.floor(progress)

                            calculatedProgress = roundedProgress // ← Guardar en variable local
                            calculatedDataProgress = {
                                name:
                                    'Progreso mensual' +
                                    ' ' +
                                    count +
                                    '/' +
                                    step?.checkins,
                                progress: roundedProgress,
                                count_total: roundedProgress + '%',
                                relev: count,
                            }
                        }
                        console.log('SSS', JSON.stringify(step))
                    }
                    if (step) {
                        if (step?.checkins) {
                            const count =
                                await schedulesServices.get_total_checkin_count(_id)
                            const progress = (count / step?.checkins) * 100
                            const roundedProgress = Math.floor(progress)

                            calculatedProgress =
                                roundedProgress <= 100 ? roundedProgress : 100

                            // console.log('==========> expoConfig.slug => ', expoConfig.slug)
                            if (
                                expoConfig.slug === CLIENTS_SLUGS.JTI_CONNECT ||
                                expoConfig.slug === CLIENTS_SLUGS.DOTS ||
                                expoConfig.slug === CLIENTS_SLUGS.DOTS_II
                            ) {
                                activeForm(calculatedProgress, formFinishStatus)
                            }
                        }
                    }
                }
                console.log(
                    '🚀 ~ calculatedDataProgress ~ calculatedDataProgress:',
                    calculatedDataProgress,
                )
                setProgressRelev(calculatedProgress)
                if (calculatedDataProgress) {
                    setDataProgress(calculatedDataProgress)
                }

                // los demas progresos dinamicos
                try {
                    if (
                        schedule.additional &&
                        schedule.additional.objective &&
                        schedule.additional.objective.length > 1
                    ) {
                        const additionalObjectives =
                            schedule.additional.objective.slice(1) // saco el primero porque es el de las tiendas
                        let array_progress = []
                        for (const objective of additionalObjectives) {
                            if (objective['form'].length == 0) {
                                continue
                            }
                            const formsCountTotal =
                                await schedulesServices.getProgressByForms(
                                    _id,
                                    objective['form'],
                                )
                            // console.log('🚀 ~ calculateRelevProgress ~ formsCountTotal:', formsCountTotal, 'objective:', objective)
                            const name = await schedulesServices.getFormName(
                                objective['form'][0],
                            )
                            const progress =
                                (formsCountTotal / parseInt(objective.objetive)) *
                                100
                            const roundedProgress = Math.floor(progress)
                            array_progress.push({
                                _id: objective['form'][0],
                                name: name,
                                progress: roundedProgress,
                                count_total:
                                    formsCountTotal + '/' + objective.objetive,
                            })
                        }
                        console.log(
                            '🚀 ~ calculateRelevProgress ~ array_progress:',
                            array_progress,
                        )
                        setProgressAdditional(array_progress)
                    }
                } catch (error) {
                    console.error('1- 🚀 ~ calculateRelevProgress ~ error:', error)
                }
            }
        } catch (error) {
            console.error('2- 🚀 ~ calculateRelevProgress ~ error:', error)
        }
    }

    const getProgresStores = async () => {
        try {
            const statusMap = getStatusMap(languageFile)
            if (schedule_id) {
                await schedulesServices
                    .getProgressStatus(schedule_id, statusMap)
                    .then((items) => {
                        setStoresProgress(items)
                    })
            }
        } catch (error) {
            console.error(error)
        }
    }

    const activeForm = async (currentProgress: number, formFinishStatus: any) => {
        console.log('🚀 ~ activeForm ~ currentProgress:', currentProgress)
        if (schedule) {
            const { form_init, form_finish, _id, date_init, date_finish } = schedule

            if (isInvalidData(form_finish)) {
                // console.log('valor invalido => form_finish => ', form_finish)
                return
            }

            console.log('🚀 ~ activeForm ~ formFinishStatus:', formFinishStatus)
            const allObjectivesComplete = progressAdditional.every(
                (item) => item.progress >= 100,
            )

            console.log('progressRelev => ', progressRelev)
            console.log('formFinishStatus => ', formFinishStatus)
            console.log('allObjectivesComplete => ', allObjectivesComplete)
            console.log(
                'currentProgress >= 100 && !formFinishStatus && allObjectivesComplete => ',
                currentProgress >= 100,
                !formFinishStatus,
                allObjectivesComplete,
            )

            if (
                currentProgress >= 100 &&
                !formFinishStatus &&
                allObjectivesComplete
            ) {
                let title = languageFile.active_vespertino
                let desc = languageFile.completed_your_mandatory_objectives
                let button = languageFile.complete_now
                let buttonDissmis = languageFile.perform_later

                const goto = async () => {
                    await navigateToForms(-1).then(() => closeBottomSheet(true))
                }

                const hasSeenModal = await AsyncStorage.getItem('hasSeenModalVesp')
                console.log(
                    '🚀 ~ activeForm ~ hasSeenModal:',
                    hasSeenModal,
                    !hasSeenModal,
                )

                if (!hasSeenModal) {
                    openBottomSheet(
                        <BottomSheetAlert
                            image={require('../../../assets/stores/activeVespertino.png')}
                            title={title}
                            desc={desc}
                            buttonGoto={button}
                            button={buttonDissmis}
                            closeBottomSheet={closeBottomSheet}
                            goto={goto}
                        />,
                        ['50%'],
                    )
                    await AsyncStorage.setItem('hasSeenModalVesp', 'true')
                    //setIsModalSeen(true)
                }
            }
        }
    }

    const expoConfig = Constants.expoConfig || { slug: '' }

    // console.log('DEBERIA MOSTRAR MAPA ==>', showMapButton)

    useEffect(() => {
        //@TODO : Revisar multiples llamados al effect y render de objetivos realizados
        calculateRelevProgress()
        getProgresStores()
    }, [formsContext, steps, form, schedule, selectedDate, buttonDistributor])

    const handleOffRoute = () => {
        let title = languageFile.back_to_your_agenda
        let desc = languageFile.return_to_the_current_day
        let button = languageFile.continue
        let buttonDissmis = languageFile.cancel

        const currentDateFormat = formatDate(new Date())

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/stores/returnToAgenda.png')}
                title={title}
                desc={desc + `${currentDateFormat}`}
                buttonGoto={button}
                button={buttonDissmis}
                closeBottomSheet={closeBottomSheet}
                goto={navigateToCurrentDate}
            />,
        )
    }

    const navigateToCurrentDate = () => {
        const currentDateObject = getCurrentDateObject()

        selectDay(currentDateObject)

        closeBottomSheet(true)
    }
    const goToMap = () => {
        console.log('🗺️ [goToMap] Botón presionado')
        console.log('🗺️ [goToMap] Parámetros:', {
            selectedScheduleID: schedule_id,
            campaign_schedule_free: scheduleFree,
            steps: steps?.length,
        })
        if ((form && !form.completed && form.progressive_mode) || showAlert) {
            console.log(
                '⚠️ [goToMap] Bloqueado por form.progressive_mode o showAlert',
            )
        } else {
            console.log('✅ [goToMap] Navegando a MapScreen...')
            navigation.navigate('MapScreen', {
                selectedScheduleID: schedule_id,
                campaign_schedule_free: scheduleFree,
                campaignSteps: steps,
            })
        }
    }

    const orderedstoresProgress = storesProgress.sort((a, b) => {
        const order = [
            'en revisión',
            'aprobado',
            'desaprobado',
            'realizado',
            'en curso',
            'ocupado',
            'pendiente',
        ]
        const labelA = a.label ? a.label.toLowerCase() : ''
        const labelB = b.label ? b.label.toLowerCase() : ''
        return order.indexOf(labelA) - order.indexOf(labelB)
    })

    const [iconSize, setIconSize] = useState(16)

    // Detectar si el tamaño de la fuente ha sido aumentado
    useEffect(() => {
        const fontScale = 1
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(16) // Valor normal
        }

        const checkDownloadPerfectStore = async () => {
            // const isDownloadAssetsPS = await schedulesServices.isTotalAssetsDownloaded()
            // // setIsDownloadedComplete(isDownloadAssetsPS)
            // setIsDownloadedCompletePS(isDownloadAssetsPS)

            const isUserContentZipStore = await StorageAdapter.getItem(
                ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP_PS,
            )
            const isUserContentZip = isUserContentZipStore
                ? isUserContentZipStore == 'true'
                : false
            console.log(
                '🚀 ~ Aca paso en que momento? ~ isUserContentZip:',
                isUserContentZip,
            )
            setIsPerfectStoreZip(isUserContentZip)
        }

        const checkHasStoreZip = async () => {
            const hasStoreZip = await StorageAdapter.getItem(
                ASYNC_STORAGE_KEYS.HAS_STORES_ZIP,
            )
            setHasStoresZip(hasStoreZip && hasStoreZip === 'true')
        }

        checkDownloadPerfectStore()
        checkHasStoreZip()
    }, [])

    useEffect(() => {
        setIsPerfectStoreZip(showDownloadAssetPS)
    }, [showDownloadAssetPS])

    useFocusEffect(
        useCallback(() => {
            return () => {
                setShowMore(false)
            }
        }, []),
    )

    const validateProgressBar =
        expoConfig.slug != CLIENTS_SLUGS.JTI_CONNECT &&
        expoConfig.slug != CLIENTS_SLUGS.DANONE_ONE &&
        expoConfig.slug != CLIENTS_SLUGS.DOTS &&
        expoConfig.slug != CLIENTS_SLUGS.DOTS_II &&
        expoConfig.slug != CLIENTS_SLUGS.MARS

    const progress1 =
        expoConfig.slug === CLIENTS_SLUGS.MITSUBISHI
            ? 'Avance de visitas'
            : languageFile.your_progress_in_stores
    const progress2 =
        expoConfig.slug === CLIENTS_SLUGS.MITSUBISHI
            ? 'Progreso'
            : languageFile.daily_survey

    return (
        <View style={styles.container}>
            <LinearGradient
                style={styles.containerCampaignData}
                colors={[
                    theme.colors.linearGradientStart,
                    theme.colors.linearGradientEnd,
                ]}
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
            >
                <View
                    style={[
                        styles.containerCampaignHeader,
                        (form && !form.completed && form.progressive_mode) ||
                        showAlert
                            ? { opacity: 0.5 }
                            : null,
                    ]}
                >
                    <View
                        style={[
                            styles.flexDirectionRow,
                            { flex: showMapButton && showMapButton ? 3 : 1 },
                        ]}
                    >
                        {/*<Feather name='truck' size={iconSize} color={'white'} style={styles.marginRight} />*/}
                        <Text style={[styles.textSurvey]}>
                            {buttonDistributor && buttonDistributor.name
                                ? buttonDistributor.name
                                : validatesNamesCampaing()
                                  ? 'Progreso del mes'
                                  : progress1}
                        </Text>
                    </View>

                    {(isPerfectStoreZip || !hasStoresZip) && (
                        <AssetsDownloadedPS
                            hasStoresZip={hasStoresZip}
                            isComplete={isDownloadedComplete}
                        />
                    )}

                    {/* <TouchableOpacity onPress={() => setShowMore(!showMore)}>
                        <Feather
                            style={styles.paddingLeft}
                            name={!showMore ? 'chevron-down' : 'chevron-up'}
                            size={iconSize}
                            color={'white'}
                        />
                    </TouchableOpacity> */}
                </View>
                <Text
                    style={[
                        styles.textInfoSurvey,
                        { marginLeft: 12, marginVertical: 4 },
                    ]}
                >
                    {dataProgress ? dataProgress.name : progress2}

                    {form && form?.name && !showAlert ? (
                        <TouchableOpacity
                            style={styles.formButton}
                            onPress={() => navigateToForms(-1)}
                        >
                            <Text style={styles.mainButtonText}>{form?.name}</Text>
                        </TouchableOpacity>
                    ) : progressRelev && progressRelev >= 100 ? (
                        <Text
                            style={{
                                color: '#92EA64',
                                fontSize: 15,
                                marginStart: 6,
                                fontWeight: '500',
                            }}
                        >
                            {'    '}
                            Objetivo cumplido
                        </Text>
                    ) : null}
                </Text>
                {/* BARRA DE PROGRESO */}
                <View style={[styles.containerProgress]}>
                    {validateProgressBar ? (
                        <CampaignCustomBar
                            values={orderedstoresProgress}
                            width={180}
                        />
                    ) : (
                        <Progress.Bar
                            progress={progressRelev / 100}
                            height={10}
                            width={null}
                            style={styles.progressBar}
                            color={colorFilledBis}
                            unfilledColor={'#ffffff68'}
                        />
                    )}

                    <Text
                        style={[
                            styles.textProgressSurvey,
                            { marginStart: 8, marginEnd: 20 },
                        ]}
                    >
                        {dataProgress
                            ? dataProgress.count_total
                            : progressRelev + '%'}
                    </Text>
                    {showMapButton && showMapButton == true && (
                        <TouchableOpacity
                            style={styles.containerGoToMap}
                            onPress={() => goToMap()}
                        >
                            <Feather name='map-pin' size={14} color={'white'} />
                            <Text style={styles.textGoToMap}>
                                {languageFile.map}
                            </Text>
                        </TouchableOpacity>
                    )}
                </View>
                <View style={[styles.paddingBottom]} />

                {/* {showMore && (
                    <View style={styles.paddingBottom}>
                        {progressAdditional.map((form, index) => (
                            <View key={form._id.toString()}>
                                <View style={styles.containerProgress}>
                                    <Progress.Bar
                                        progress={form.progress / 100}
                                        height={10}
                                        width={width - 76}
                                        style={styles.progressBar}
                                        color={colorFilledBis}
                                        unfilledColor={colorUnfilled}
                                    />
                                </View>
                                <View style={styles.containerDailySurvey}>
                                    <Text style={styles.textInfoSurvey}>
                                        {form.name}
                                    </Text>
                                    <Text style={styles.textProgressSurvey}>
                                        {expoConfig.slug ==
                                            CLIENTS_SLUGS.DANONE_ONE ||
                                        expoConfig.slug == CLIENTS_SLUGS.DOTS ||
                                        expoConfig.slug == CLIENTS_SLUGS.DOTS_II
                                            ? form.count_total
                                            : form.progress}
                                        {expoConfig.slug ==
                                            CLIENTS_SLUGS.DANONE_ONE ||
                                        expoConfig.slug == CLIENTS_SLUGS.DOTS ||
                                        expoConfig.slug == CLIENTS_SLUGS.DOTS_II
                                            ? ''
                                            : '%'}
                                    </Text>
                                </View>
                            </View>
                        ))}

                        <View style={styles.spacer2}></View>
                        <CampaignStatusTags
                            values={orderedstoresProgress}
                            dataProgress={dataProgress}
                        />
                    </View>
                )} */}

                {formsProgress.length === 1 &&
                    formsProgress.map((form, index) => (
                        <View key={form._id} style={styles.containerFormCompleted}>
                            <Text style={styles.textPercentage}>
                                {form?.progress}%
                            </Text>
                            <Text style={styles.textForm}>{form?.name}</Text>
                            <Text style={styles.textFormDate}>
                                {format(new Date(form?.date), 'dd/MM/yyyy, hh:mm')}{' '}
                                hs.
                            </Text>
                        </View>
                    ))}

                {formsProgress.length === 2 && (
                    <View style={styles.containerFormProgress}>
                        {formsProgress.map((form, index) => (
                            <View key={form._id} style={styles.formsProgress}>
                                <Text style={styles.textPercentage}>
                                    {form?.progress}%
                                </Text>
                                <View>
                                    <Text style={styles.textForm}>{form?.name}</Text>
                                    <Text style={styles.textFormDate}>
                                        {format(
                                            new Date(form?.date),
                                            'dd/MM/yyyy, hh:mm',
                                        )}{' '}
                                        hs.
                                    </Text>
                                </View>
                                <View style={styles.dividerVerticalLine}></View>
                            </View>
                        ))}
                    </View>
                )}
                {showAlert ? (
                    <TouchableOpacity
                        activeOpacity={0.7}
                        onPress={() => handleOffRoute()}
                    >
                        <View style={styles.spacer1}></View>
                        <LinearGradient
                            style={[styles.linearGradient, { marginBottom: 15 }]}
                            colors={[
                                theme.colors.colorPrimary,
                                theme.colors.linearGradientStart,
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        >
                            <View style={styles.containerAlert}>
                                <Image
                                    style={styles.alertImage as any}
                                    source={require('../../../assets/stores/alert.png')}
                                />
                                <Text style={[styles.offRoute, { flex: 1 }]}>
                                    {languageFile.off_route}
                                </Text>
                            </View>
                        </LinearGradient>
                    </TouchableOpacity>
                ) : null}
            </LinearGradient>
        </View>
    )
}

export const AssetsDownloadedPS = ({ hasStoresZip, isComplete }) => {
    const { languageFile } = getLanguage()
    const uri = isComplete
        ? require('../../../assets/cloudCheck.png')
        : require('../../../assets/cloudArrowDown.png')
    const setShowAlertSnackbar = useAlertsGeneralControllersStore(
        (store) => store.setShowAlertSnackbar,
    )
    const setTextFinally = useAlertTextPS((store) => store.setTextFinally)
    const clickAlert = () => {
        if (!hasStoresZip) {
            return
        }
        if (isComplete) {
            setTextFinally(languageFile.perfect_store_download)
            setShowAlertSnackbar(true)
        } else {
            setShowAlertSnackbar(true)
        }
    }
    return (
        <TouchableOpacity onPress={() => clickAlert()}>
            <View style={{ marginHorizontal: 12 }}>
                <Image
                    style={{ width: 26, height: 26 }}
                    tintColor={
                        hasStoresZip ? (isComplete ? 'white' : 'black') : 'red'
                    }
                    source={uri}
                />
            </View>
        </TouchableOpacity>
    )
}

export const CampaignCustomBar = ({
    values,
    width,
}: {
    values: CampaignValuesModel[]
    width: number
}) => {
    let total = values.reduce((acc, item) => acc + item.value, 0)
    console.log('🚀 ~ CampaignCustomBar ~ values:', values.length)
    console.log('🚀 ~ CampaignCustomBar ~ total:', total)
    return (
        <View style={[styles.containerCampaignProgress, { width: width }]}>
            {values.map((item, index) => {
                let percentage = (item.value / total) * 100
                let barWidth = (width * percentage) / 100
                console.log(
                    'ANCHO DE BARRA ==>',
                    barWidth,
                    '% DE BARRA ==>',
                    percentage,
                    ' PARA ITEM => ',
                    item.label,
                )
                let color = item.color_hex ?? 'white'
                if (Number.isNaN(barWidth)) {
                    barWidth = 0
                }
                //? let l = console.log(percentage, barWidth)

                return (
                    <View
                        key={index}
                        style={{ width: barWidth, backgroundColor: color }}
                    ></View>
                )
            })}
        </View>
    )
}

export const CustomBar = ({
    values,
    total,
    progress_color,
}: {
    values: number[]
    total: number
    progress_color: string
}) => {
    let width = Dimensions.get('window').width

    return (
        <View style={styles.containerCampaignProgress}>
            {values.map((item, index) => {
                let percentage = (item / total) * 100
                let barWidth = (width * percentage) / 100

                return (
                    <View
                        style={{ width: barWidth, backgroundColor: progress_color }}
                    ></View>
                )
            })}
        </View>
    )
}
export const CampaignStatusTags = ({
    values,
    dataProgress,
}: {
    values: CampaignValuesModel[]
    dataProgress: {
        name: string
        progress: string
        count_total: string
        relev: string
    }
}) => {
    const [newValues, setNewValues] = useState([])
    const { languageFile } = getLanguage()

    useEffect(() => {
        const newValuesConfig = async () => {
            const validate = validatesNamesCampaing()

            if (validate) {
                const totalStores = await UserServices.getGlobalVersion(
                    SCHEDULES_STORE_NAMES.COUNT_STORES,
                )

                const newValues = []
                for (const value of values) {
                    if (value.label !== languageFile?.pending_mayus) {
                        if (value.label == languageFile?.visited_mayus) {
                            if (value.color_hex == '#FFDE39') {
                                value.label = languageFile?.checkin_realized_sync
                            } else {
                                value.label = languageFile?.visited_store_mayus
                            }
                        }
                        newValues.push(value)
                    }
                }

                if (dataProgress) {
                    newValues.push({
                        label: 'RELEVAMIENTOS',
                        value: dataProgress.relev,
                        color_hex: '#FFFFFF',
                    })
                }

                newValues.push({
                    label: 'TOTAL TIENDAS',
                    value: totalStores,
                    color_hex: '#95919F',
                })

                setNewValues(newValues)
                return newValues
            } else {
                setNewValues(values)
            }
        }

        newValuesConfig()
    }, [])
    return (
        <View
            style={{
                flexWrap: 'wrap',
                flexDirection: 'row',
                marginHorizontal: 12,
                gap: 8,
            }}
        >
            {newValues.map((item, index) => {
                return (
                    <View key={index} style={[styles.containerReferences]}>
                        <View
                            style={[
                                styles.circlesReferences,
                                { backgroundColor: item.color_hex },
                            ]}
                        />
                        <Text style={[styles.textForm, { marginStart: 6 }]}>
                            {item.label.capitalize()} / {item.value}
                        </Text>
                    </View>
                )
            })}
        </View>
    )
}
